import type { LocationSummary } from '../domain/types'

/**
 * Transform raw Strapi location response to LocationSummary
 */
export function transformToLocationSummary(raw: any): LocationSummary {
  return {
    id: raw.id,
    documentId: raw.documentId,
    name: typeof raw.name === 'object' ? (raw.name?.en ?? raw.name?.ar ?? '') : (raw.name ?? ''),
    code: raw.code ?? '',
    status: raw.status ?? 'active',
    locationType: raw.locationType
      ? {
          id: raw.locationType.id,
          code: raw.locationType.code,
          name: raw.locationType.name,
        }
      : undefined,
    factoryDocumentId: raw.factoryDocumentId ?? null,
  }
}
